import type { WebCheckoutEventForLogEvent } from '~/models/checkout/TeliaPayWebCheckoutEvent.model';
import FetchFactory from '../factory';
import type { TeliaPayStandaleResultData } from '~/composables/checkout/useTeliaPay';

const TELIA_PAY_CONTROLLER_PATH = '/api-electra/TeliaPay';
const TELIA_PAY_CHECKOUT_CONTROLLER_PATH = '/api-electra/TeliaPayCheckout';

class TeliaPay extends FetchFactory<any> {
  async getTeliaPayToken(): Promise<any> {
    return await this.get(`${TELIA_PAY_CONTROLLER_PATH}/GetTeliaPayToken`);
  }

  async postTeliaPayResult(data: any): Promise<any> {
    return await this.post(`${TELIA_PAY_CHECKOUT_CONTROLLER_PATH}/tpresultv2`, {
      ...data,
    });
  }

  async postTeliaPayEvent(
    webCheckoutEvent: WebCheckoutEventForLogEvent,
  ): Promise<any> {
    return await this.post(`${TELIA_PAY_CHECKOUT_CONTROLLER_PATH}/tpevent`, {
      ...webCheckoutEvent,
    });
  }

  async getTeliaStandalone(orderGuid: string): Promise<any> {
    return await this.get(
      `${TELIA_PAY_CONTROLLER_PATH}/TeliaPayStandalone?orderGuid=${orderGuid}`,
    );
  }

  async postTeliaPayStandaloneResult(
    data: TeliaPayStandaleResultData,
  ): Promise<any> {
    return await this.post(
      `${TELIA_PAY_CHECKOUT_CONTROLLER_PATH}/tpresultstandalonev2`,
      data,
    );
  }
}

export default TeliaPay;
